<template>
    <div class="useful">
        <span class="mt-1"> {{ $t('discussions.useful') }} </span>

        <div class="useful__button" @click.prevent="ratePost('like', post)">
            <img
                v-lazy-load
                src="/nuxt-assets/images/lazy-load-error.svg"
                data-src="/nuxt-assets/images/icons/like.svg"
                :alt="likesCountText"
            />
            {{ likesCountText }}
        </div>

        <span class="useful__pipe"></span>

        <div class="useful__button" @click.prevent="ratePost('dislike', post)">
            <img
                v-lazy-load
                src="/nuxt-assets/images/lazy-load-error.svg"
                data-src="/nuxt-assets/images/icons/dislike.svg"
                :alt="likesCountText"
            />
            {{ dislikesCountText }}
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import PostModel from '~/models/Discussion/Post'
import { useBasketStore } from '~/stores/basket'
import { useAuthStore } from '~/stores/auth'
import CounsellingQuestion from '~/models/Counselling/CounsellingQuestion'

export default {
    props: {
        post: {
            type: Object as PropType<PostModel | CounsellingQuestion>,
            default: null,
            required: true,
        },
    },
    computed: {
        authUser(): object | null {
            const basketStore = useBasketStore()
            return basketStore.authUser
        },
        isUserAuthenticated(): boolean {
            return this.authUser !== null
        },
        likesCountText(): string {
            return this.post.likesCount > 0 ? '(' + this.post.likesCount + ')' : ''
        },
        dislikesCountText(): string {
            return this.post.dislikesCount > 0 ? '(' + this.post.dislikesCount + ')' : ''
        },
    },
    methods: {
        ratePost(type: 'like' | 'dislike', post: PostModel | CounsellingQuestion): void {
            const authStore = useAuthStore()
            const accessToken: string | null = authStore.accessToken

            if (!this.isUserAuthenticated) {
                useNuxtApp().$bus.$emit('openModalForLogin')
                return
            }

            if (type === 'like') {
                post.likesCount += post.hasUserLikedQuestion ? -1 : 1
                post.dislikesCount -= post.hasUserDislikedQuestion ? 1 : 0
                post.hasUserLikedQuestion = !post.hasUserLikedQuestion
                post.hasUserDislikedQuestion = false

                this.$repository.discussionLikePost(post.id, { accessToken })
            } else {
                post.dislikesCount += post.hasUserDislikedQuestion ? -1 : 1
                post.likesCount -= post.hasUserLikedQuestion ? 1 : 0
                post.hasUserDislikedQuestion = !post.hasUserDislikedQuestion
                post.hasUserLikedQuestion = false

                this.$repository.discussionDislikePost(post.id, { accessToken })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.useful {
    position: relative;
    display: flex;
    justify-content: right;
    font-size: 12px;
    color: $color-grey-semi-dark;
    margin: 1rem 0;
    flex: 0 0 auto;
    width: auto;
    bottom: -5px;

    @include screen-md {
        margin-top: 0;
        justify-content: flex-end;
    }

    &__pipe {
        background: $color-grey-semi-dark;
        height: 24px;
        width: 1px;
        display: block;
        position: relative;
        top: -3px;
    }

    &__button {
        cursor: pointer;
        padding: 0 5px;
        margin: 0 2px;
    }
}
</style>
